import type { CSSProperties } from "react";

interface HalftoneArtSource {
  src: string;
  width: number;
  height: number;
}

export const ABOUT_ART = {
  bayBridge: {
    src: "/marketing/about/bay-bridge.svg",
    width: 1536,
    height: 356,
  },
  skyline: {
    src: "/marketing/about/sf-skyline.svg",
    width: 1536,
    height: 408,
  },
} satisfies Record<string, HalftoneArtSource>;

/**
 * The art files are vector dot fields, used as a mask so the dots stay sharp at
 * any pixel ratio and take their colour from the element's background utility.
 */
export function HalftoneArt({
  art,
  label,
  className,
}: {
  art: HalftoneArtSource;
  label?: string;
  className?: string;
}) {
  const style: CSSProperties = {
    aspectRatio: `${art.width} / ${art.height}`,
    maskImage: `url(${art.src})`,
    WebkitMaskImage: `url(${art.src})`,
  };
  return (
    <div
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={style}
      className={`mask-contain mask-center mask-no-repeat select-none ${className ?? ""}`}
    />
  );
}
